import React from "react";
import { AdsSortOption, AllTypeCategory } from "../../../models";
import ModuleFilterSection from "./ModuleFilterSection";

const ModuleSearchSection = props => {
  const {
    module,
    levelCount,
    numberOfControls,
    location,
    selectedCategory,
    category,
  } = props;

  const handleFilterSubmit = (values, isToggle = false) => {
    const { onSubmit, module } = props;

    const sortOption = AdsSortOption.DateDesc;
    const localQueryParams = {
      ...values,
      page: 1,
      sortOption,
      category: values.category || props.categoryName || selectedCategory
    };

    onSubmit(
      module === AllTypeCategory.name ? undefined : module,
      localQueryParams
    );
  };

  return (
    <React.Fragment>
      <ModuleFilterSection
        onSubmit={handleFilterSubmit}
        module={module === AllTypeCategory.name ? undefined : module}
        categories={levelCount}
        category={category}
        selectedCategory={selectedCategory}
        numberOfControls={numberOfControls}
        location={location}
      />
    </React.Fragment>
  );
};

export default ModuleSearchSection;



// WEBPACK FOOTER //
// ./src/containers/ModulePage/ModuleSeaarchSection/index.tsx